<template>
  <component
    :is="tag"
    v-if="!animationDone"
    class="flex flex-wrap overflow-hidden">
    <span
      v-for="(word, i) in words"
      :key="i"
      class="overflow-hidden whitespace-pre">
      <Presence
        v-for="(letter, k) in word"
        :key="k">
        <Motion
          v-if="visible"
          :initial="{ y: 100, opacity: 0 }"
          :animate="{
            y: [100, 0],
            opacity: [0, 1],
            transition: { delay: (i === 0 ? k : k + words.slice(0, i).join('').length) * 0.01 + 0.3 }
          }"
          :exit="{ y: -100, opacity: 0 }"
          :transition="{
            delay: (i === 0 ? k : k + words.slice(0, i).join('').length) * 0.01,
            duration: 0.5,
            enter: { delay: 3 },
            ease: [0.33, 1, 0.68, 1]
          }"
          tag="span"
          class="inline-block">
          {{ letter }}
        </Motion>
      </Presence>
      <span
        v-if="i + 1 < words.length"
        class="flex-shrink-0"
        >&nbsp;</span
      >
    </span>
  </component>

  <component
    :is="tag"
    v-else>
    {{ copy }}
  </component>
</template>

<script setup lang="ts">
  // @ts-nocheck
  import { ref } from 'vue'

  import { Motion, Presence } from '@motionone/vue/dist/motion-vue.ssr.js'

  type animatedTextProps = {
    copy: string
    tag: string
    visible: boolean
  }

  const props = defineProps<animatedTextProps>()

  const words = props.copy.split(' ')

  const animationDone = ref(false)
</script>
